import { Uuid } from "@/domains/global/identifiers";
import { uuidModule } from "@/modules/uuid";
import { resolveNoteSourceSyncModelUuid } from "@/modules/uuid/sync-models/resolveNoteSourceSyncModelUuid";
import { AppStore } from "@/store/AppStore";
import { CreateNoteSourceOperation } from "@/store/sync/operations/sources/CreateNoteSourceOperation";
import { CreateSourceOperation } from "@/store/sync/operations/sources/CreateSourceOperation";

const AUDIO_SOURCE_PRIMARY_LABEL = "Voice Recording";

export const ensureSourceForRecording = async ({
  store,
  audioRecordingId,
  noteId,
}: {
  store: AppStore;
  audioRecordingId: Uuid;
  noteId: Uuid | null;
}): Promise<void> => {
  if (!noteId) return;

  const capturedAudioId = uuidModule.resolveAudioRecordingCapturedAudioUuid({
    associatedAudioRecordingId: audioRecordingId,
  });
  const sessionId = uuidModule.resolveCapturedAudioSessionSyncModelUuid({
    capturedAudioId,
  });
  const sessionArtifactId = uuidModule.resolveSessionArtifactIdForCapturedAudio({
    sessionId,
    capturedAudioId,
  });
  const sourceId = uuidModule.resolveSourceIdForSessionArtifact({
    sessionId,
    sessionArtifactId,
  });
  const noteSourceId = resolveNoteSourceSyncModelUuid({ noteId, sourceId });

  const existingSource = await store.sources.getAsync(sourceId);
  if (!existingSource) {
    await new CreateSourceOperation({
      store,
      payload: {
        id: sourceId,
        schema_version: 1,
        source_kind: "AUDIO",
        primary_label: AUDIO_SOURCE_PRIMARY_LABEL,
        secondary_label: null,
        associated_audio_recording_id: audioRecordingId,
      },
    }).execute();
  }

  const existingNoteSource = await store.noteSources.getAsync(noteSourceId);
  if (!existingNoteSource) {
    await new CreateNoteSourceOperation({
      store,
      payload: {
        id: noteSourceId,
        schema_version: 1,
        note_id: noteId,
        source_id: sourceId,
      },
    }).execute();
  }
};
